import api from './api';
import { CrvProduct, CraProduct, PhProduct } from '../types/InvestmentProduct';

// CRV Product Service
export const crvProductService = {
  getAll: () => api.get<CrvProduct[]>('/products/crv'),
  getById: (id: string) => api.get<CrvProduct>(`/products/crv/${id}`),
  create: (data: CrvProduct) => api.post<CrvProduct>('/products/crv', data),
  update: (id: string, data: CrvProduct) => api.put<CrvProduct>(`/products/crv/${id}`, data),
  delete: (id: string) => api.delete(`/products/crv/${id}`),
};

// CRA Product Service
export const craProductService = {
  getAll: () => api.get<CraProduct[]>('/products/cra'),
  getById: (id: string) => api.get<CraProduct>(`/products/cra/${id}`),
  create: (data: CraProduct) => api.post<CraProduct>('/products/cra', data),
  update: (id: string, data: CraProduct) => api.put<CraProduct>(`/products/cra/${id}`, data),
  delete: (id: string) => api.delete(`/products/cra/${id}`),
};

// PH Product Service
export const phProductService = {
  getAll: () => api.get<PhProduct[]>('/products/ph'),
  getById: (id: string) => api.get<PhProduct>(`/products/ph/${id}`),
  create: (data: PhProduct) => api.post<PhProduct>('/products/ph', data),
  update: (id: string, data: PhProduct) => api.put<PhProduct>(`/products/ph/${id}`, data),
  delete: (id: string) => api.delete(`/products/ph/${id}`),
};
